// ──────────────────────────────────────────────
// src/index/js/index.js — Entrada principal INDEX
// ──────────────────────────────────────────────

window.isWebkit = /webkit/i.test(navigator.userAgent);

// ─────── CSS   ─────── 
import '@vendor/bootstrap/icon/bootstrap-icons.css';
import '@vendor/themify-icons/themify-icons.css';
import '@css/styleasistencia.scss';
 
// ✅ Importa todo Bootstrap con Popper incluido y Data API activada
//import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// ─────── JS VENDOR ───────
//import '@js/jquery-3.5.1.min.js';
//import '@vendor/bootstrap/dist/js/bootstrap.bundle.js';
//import 'expose-loader?exposes=regula!@vendor/regula/regula.min.js';
//import '@js/color-modes.js';

// ─────── Log final ───────
console.log("🚀 Bundle INDEX cargado correctamente");


 
//@import '@vendor/fontawesome/css/all.min.css';
//@import '@vendor/wow/animate.css';
